import React from "react";
import * as echarts from "echarts/core";
// import ReactEcharts from "echarts-for-react";
import ReactEChartsCore from "echarts-for-react/lib/core";
import { PieChart } from "echarts/charts";

const Pie = (props) => {
  echarts.use([PieChart]);
  const data = props.pieData;
  const getOption = {
    grid: {
      left: 0,
      top: 0,
    },
    legend: {
      icon: "circle",
      orient: "vertical",
      selectedMode: false,
      top: "35",
      right: "0",
      itemWidth: 20,
      // itemHeight: 20,
      itemGap: 17,
      textStyle: {
        color: "#ffffff",
        fontFamily: "MicrosoftYaHei",
      },
      animation: false,
      formatter: function (name) {
        var target;
        for (let i = 0, l = data.length; i < l; i++) {
          if (data[i].name == name) {
            target = data[i].value;
          }
        }
        var arr = ["{a|" + target + "}", "{b|" + name + "}"];
        return arr.join("\n");
      },
      textStyle: {
        rich: {
          a: {
            fontSize: 28,
            // verticalAlign: "top",
            // align: "center",
            padding: [20, 0, 3, 0],
            // margin: [10, 0, 0, 0],
            color: '#ffffff',
            fontWeight: 700,
          },
          b: {
            fontSize: 14,
            // align: "center",
            // padding: [0, 10, 0, 0],
            // lineHeight: 25,
            color: '#ffffff',
            opacity: 0.6
          },
        },
      },
    },
    color: ["#038AD7", "#5EC4FF", "#9F49FF", "#FF7675", "#326CEF"],
    series: [
      {
        name: "Access From",
        type: "pie",
        radius: ["66%", "90%"],
        center: ["37%", "53%"],
        avoidLabelOverlap: false,
        silent: true,
        itemStyle: {
          // borderRadius: 10,
          borderColor: "#151E4A",
          borderWidth: 5,
        },
        label: {
          show: false,
          position: "center",
        },
        labelLine: {
          show: false,
        },
        data: props.pieData,
      },
    ],
  };
  return (
    <>
      <ReactEChartsCore
        echarts={echarts}
        style={{
          height: "350px",
          // width: '500px',
          //   border: '1px solid #dadada',
        }}
        option={getOption}
      />
    </>
  );
};

export default Pie;
